import IconCancel from '@pages/Payment/Components/IconCancel'
import { detectEnvUat } from '@utils/general'
import { Modal } from 'antd'
import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { RootState } from 'store'
import { Type_Initstate } from 'store/appSlice'
import DownloadQrImage from './DownloadQrImage'
import QrExpiryNotice from './QrExpiryNotice'

interface IProps {
  img?: string
  isModalOpen: boolean
  expiresAtMs?: number
  allowCancel?: boolean
  isSkipSelectBill?: boolean
  setIsModalOpen: (value: boolean) => void
}

const ModalBIDV: FC<IProps> = ({
  isModalOpen,
  img,
  allowCancel,
  setIsModalOpen,
  isSkipSelectBill,
  expiresAtMs,
}: IProps) => {
  const navigate = useNavigate()
  const params = useParams()

  const appState = useSelector<RootState, Type_Initstate>((state) => state.app)

  const handleNavigate = () => {
    navigate(
      `${detectEnvUat() ? '/uat' : ''}/organization/${params.orgCode}/school/${params.schoolCode}/student/${
        params.studentID
      }`,
    )
  }

  const handleCancel = () => {
    if (allowCancel) {
      setIsModalOpen(false)
    } else if (window.confirm('Phiếu thu chỉ có thể tạo lại sau 15 phút. Bạn có muốn thoát !')) {
      setIsModalOpen(false)
      if (isSkipSelectBill && appState?.studenInfor?.redirect_success.length > 0) {
        window.location.replace(appState?.studenInfor?.redirect_success)
      } else {
        handleNavigate()
      }
    }
  }

  // const beforeUnLoad = (e) => {
  //   e.preventDefault()
  //   e.stopPropagation()
  //   e.returnValue = 'akdjlasjdkasjdlaksj'
  // }

  // useEffect(() => {
  //   if (isModalOpen) {
  //     window.addEventListener('beforeunload', beforeUnLoad)
  //   }

  //   return () => {
  //     window.removeEventListener('beforeunload', beforeUnLoad)
  //   }
  // }, [isModalOpen])

  return (
    <>
      <Modal title={<></>} open={isModalOpen} footer={<></>} className="p-0 custom-modal rouder-31">
        <div className="relative bg-white border-[20px] border-[#016B69] rounded-[30px] pt-4">
          <span className="absolute right-2 top-2">
            <IconCancel
              handleCancel={() => {
                handleCancel()
              }}
            />
          </span>
          <img src={`data:image/png;base64, ${img}`} alt="" className="mx-auto w-full" />
          <DownloadQrImage imageSrc={img} fileName="bidv-qr-thanh-toan.png" />
          <QrExpiryNotice
            isModalOpen={isModalOpen && !!img}
            paymentChannel="BIDV"
            resetKey={img}
            expiresAtMs={expiresAtMs}
          />
        </div>
      </Modal>
    </>
  )
}

export default ModalBIDV
